import debounce from 'lodash-es/debounce'

export default function sitraFacts(hideFactFn = hideVisibleFact, showFactFn = showRandomHiddenFact) {
  const factsContainer = document.querySelector('.js-sitra-facts-container')
  if (!factsContainer) {
    return
  }

  const facts = factsContainer.querySelectorAll('.js-sitra-facts-content')

  const debouncedHandler = debounce((facts, lastVisibleFact) => {
    showFactFn(facts, lastVisibleFact)
  }, 500)

  factsContainer.addEventListener('click', () => {
    const lastVisibleFact = hideFactFn(facts)
    debouncedHandler(facts, lastVisibleFact)
  })
}

function hideVisibleFact(facts) {
  let visibleFact = null
  facts.forEach((fact) => {
    if (!fact.classList.contains('hidden')) {
      visibleFact = fact
    }
  })

  if (visibleFact) {
    visibleFact.classList.add('slide-out-right')

    visibleFact.addEventListener('animationend', () => {
      visibleFact.classList.remove('slide-out-right')
      visibleFact.classList.add('hidden')
    }, { once: true })
  }

  return visibleFact
}

function showRandomHiddenFact(facts, lastVisibleFact) {
  let hiddenFacts = Array.from(facts).filter(fact => fact.classList.contains('hidden') && fact !== lastVisibleFact)

  if (hiddenFacts.length > 0) {
    const randomIndex = Math.floor(Math.random() * hiddenFacts.length)
    hiddenFacts[randomIndex].classList.remove('hidden')
    hiddenFacts[randomIndex].classList.add('slide-in-left')

    hiddenFacts[randomIndex].addEventListener('animationend', () => {
      hiddenFacts[randomIndex].classList.remove('slide-in-left')
    }, { once: true })
  }
}


